import React, {Component} from 'react';
import cs from 'classnames';

import './index.scss';

class MainLayout extends Component {
  static displayName = 'MyAccount-MainLayout';

  state = {
    pageTitle: '',
  };

  populateActiveNavItem = (activeNavItem) => {
    this.setState({pageTitle: activeNavItem});
  };

  render() {
    return (
      <div id="app-container" className={cs('MyAccount__Layout', this.props.className)}>
        <div className="MyAccount__Main">
          {this.state.pageTitle && <div className="MyAccount__title">{this.state.pageTitle}</div>}
          <div className="MyAccount__body">{this.props.children}</div>
        </div>
      </div>
    );
  }
}

export default MainLayout;
